import { useRef } from "react";
import type { MutableRefObject } from "react";

export type DivRefType = MutableRefObject<HTMLDivElement>;

export const useDivRef = (): DivRefType =>
  useRef<HTMLDivElement>(document.createElement('div'));
